// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ICreatePrescriberResponseModel {
    static getAttributeTypeMap() {
        return ICreatePrescriberResponseModel.attributeTypeMap;
    }
}
ICreatePrescriberResponseModel.discriminator = undefined;
ICreatePrescriberResponseModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    }
];
//# sourceMappingURL=iCreatePrescriberResponseModel.js.map